import { render, staticRenderFns } from "./ChangeSettings.vue?vue&type=template&id=a78d0ebc&scoped=true"
import script from "./ChangeSettings.vue?vue&type=script&lang=js"
export * from "./ChangeSettings.vue?vue&type=script&lang=js"
import style0 from "./ChangeSettings.vue?vue&type=style&index=0&id=a78d0ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78d0ebc",
  null
  
)

export default component.exports